/**
 * Labstep
 */

import { FieldType } from 'labstep-web/constants/form';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import { mixed } from 'yup';

export const getFieldSearchSelectEntity = (
  entityName: string,
): FieldWithoutActionProps => ({
  fieldLabel: '',
  name: 'entity',
  fieldType: FieldType.SearchSelect,
  elementProps: {
    entityName,
    labelKey: 'displayName',
  },
  validation: mixed().required(),
});
